// @flow

import * as React from 'react'

export const Apple = () => {
  return (
    <svg width="28p" height="28p" viewBox="0 0 20 20" version="1.1">
      <g
        id="_Icons/google-Copy"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <rect id="Rectangle-Copy" x="0" y="0" width="16" height="20"></rect>
        <path
          d="M15.027244,9.66990855 C15.0450094,8.28383838 15.7679016,7.00353119 16.9426541,6.27754468 C16.1981891,5.20877985 14.995961,4.55545333 13.6986424,4.51465212 C12.3337575,4.37064215 11.010561,5.3356299 10.3150406,5.3356299 C9.60606021,5.3356299 8.53519724,4.52895018 7.38205461,4.55279933 C5.8648196,4.6020732 4.48463444,5.44818047 3.74646875,6.78155508 C2.17451507,9.51731974 3.34705109,13.5379727 4.85285104,15.7493583 C5.60623463,16.8322111 6.48672377,18.0417854 7.63882601,17.9988912 C8.76622729,17.9518874 9.1872898,17.2762432 10.5481595,17.2762432 C11.8963983,17.2762432 12.2914431,17.9988912 13.4669215,17.9716187 C14.6766756,17.9518792 15.4388781,16.8839537 16.1658294,15.7908472 C16.7071343,15.0192751 17.1236675,14.1665199 17.4,13.2641691 C15.9631795,12.6533002 15.028921,11.2380815 15.027244,9.66990855 L15.027244,9.66990855 Z M12.7418714,2.8438936 C13.4286708,2.05018241 13.7670308,1.03000114 13.6850958,0 C12.6358191,0.10609382 11.6665813,0.588866303 10.9705034,1.35212491 C10.2831585,2.10518211 9.93495109,3.09038253 10.0025754,4.09073167 C11.0659217,4.10127157 12.0755465,3.64172333 12.7418714,2.8438936 L12.7418714,2.8438936 Z"
          id="Icon-Copy-4"
          fill="#000000"
          fillRule="nonzero"
        ></path>
      </g>
    </svg>
  )
}
